export function aspectRatio(){
    return document.documentElement.clientWidth/document.documentElement.clientHeight;
}